import type { ApiBrandBenefit } from '@storefronts/common-types'
import { useRotatingIndex } from './useRotatingIndex'

const ROTATION_INTERVAL_MS = 3500

/**
 * Hook for auto-rotating brand benefits carousel.
 * Resets to first benefit when benefits change. Rotates every 3.5s when 2+ benefits.
 * Single benefit: shows statically (no rotation).
 */
export function useBenefitsCarousel(benefits: ApiBrandBenefit[]): number {
    const benefitsKey = benefits.map((b) => b.id).join(',')
    return useRotatingIndex(benefits.length, benefitsKey, ROTATION_INTERVAL_MS)
}
